import * as i from 'types';
import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';

import { useSaveUser } from 'queries';

const defaultState = {
  id: '',
  email: '',
  waterMeterReadingInitial: {
    value: '',
    date: '',
  },
  waterMeterReadingFinal: {
    value: '',
    date: '',
  },
};

export type DefaultState = typeof defaultState;

export const UserContext = createContext<UserContextProps>({
  user: defaultState,
  updateLocalUserData: () => undefined,
  saveUserData: () => undefined,
});

export type UserContextProps = {
  user: DefaultState;
  updateLocalUserData: (newData: Partial<DefaultState>) => void;
  saveUserData: (data: Partial<i.SavedDataType>, method?: i.SaveMethods) => void;
};

export const UserProvider: UserProviderProps = ({ children }) => {
  const [user, setUser] = useState(defaultState);
  const { saveUser } = useSaveUser();

  const updateLocalUserData = (newData: Partial<DefaultState>) => {
    try {
      setUser({ ...user, ...newData });
    } catch (error) {
      console.error('Error updating user data:', error);
      toast.error('Er ging iets mis bij het bijwerken van gebruikersgegevens');
    }
  };

  const saveUserData = (data: Partial<i.SavedDataType>, method?: i.SaveMethods) => {
    try {
      if (!data.hasOwnProperty('user')) {
        data['user'] = user.id;
      }
      saveUser(user.id, data, method);
    } catch (error) {
      console.error('Error saving user data:', error);
      toast.error('Er ging iets mis bij het opslaan van gebruikersgegevens');
    }
  };

  return (
    <UserContext.Provider
      value={{
        user, updateLocalUserData, saveUserData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export type UserProviderProps = React.FC<{
  children: React.ReactNode;
}>;
